import { OrganizationRole } from 'src/app/shared/enums/OrganizationRole.enum';
import { OrganizationIndustry } from 'src/app/shared/enums/OrganizationIndustry.enum';

export class CompanyProfileLpRequest {
  public name: string;
  public doingBusinessAs: string;
  public registrationNumber: string;
  public roleInOrganization: OrganizationRole;
  public industry: OrganizationIndustry;
  public countryId: number;
  public stateName: string;
}
